// extracted by mini-css-extract-plugin
export default {"containerTitle":"Title_containerTitle__IrICg","title":"Title_title__O7J44"};